import React from "react";
import { Button } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

// Renders a pending catalog write awaiting the merchant's explicit confirmation.
// No write executes on the backend until Confirm is clicked.
export default function ConfirmActionCard({ pendingAction, busy, onConfirm, onCancel }) {
  if (!pendingAction) return null;
  return (
    <div className="kai-confirm-card">
      <div className="kai-confirm-title">Confirm this change</div>
      <div className="kai-confirm-summary">
        {pendingAction.summary
          ? pendingAction.summary.charAt(0).toUpperCase() + pendingAction.summary.slice(1)
          : ""}
      </div>
      <div className="kai-confirm-actions">
        <Button
          type="primary"
          size="small"
          icon={<CheckOutlined />}
          loading={busy}
          onClick={() => onConfirm(pendingAction.id)}
        >
          Confirm
        </Button>
        <Button
          size="small"
          icon={<CloseOutlined />}
          disabled={busy}
          onClick={() => onCancel(pendingAction.id)}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
}
